<template>
<el-container>
    <el-table
        :data="tableData"
        style="width: 100%;margin-top: 5%;">

        <el-table-column
          prop="propertyRecordId"
          label="变更编号"
          width="180">
        </el-table-column>

        <el-table-column
          prop="afterUsername"
          label="变更后使用人的名字"
          width="180">
        </el-table-column>

        <el-table-column
          prop="beforeUsername"
          label="变更前使用人的名字"
          width="180">
        </el-table-column>

        <el-table-column
          prop="propertyName"
          label="资产名称"
          width="180">
        </el-table-column>



          <el-table-column
            prop="recordState"
            label="变更状态"
            width="180">
            <template slot-scope="scope">
              <el-tag
              :type = "scope.row.recordState == 1?'':(scope.row.recordState==2?'success':'danger')">
                <div v-if="scope.row.recordState == 1">审核中</div>
                <div v-if="scope.row.recordState == 2">变更已完成</div>
              </el-tag>
            </template>

          </el-table-column>

        <el-table-column
          label="创建时间"
          width="180">
          <template slot-scope="scope">{{ Date(createDate) | formateDate }}</template>
        </el-table-column>


        <el-table-column
          label="修改时间"
          width="180">
          <template slot-scope="scope">{{ Date(updateData) | formateDate }}</template>
        </el-table-column>

        <el-table-column label="操作">

              <template slot-scope="scope">

                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>

              </template>
            </el-table-column>

      </el-table>

  </el-container>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Property_Deal',
     data () {
       return {
          tableData: [{
                  afterUserId:'',
                  afterUsername:'',
                  beforeUserId:'',
                  beforeUsername:'',
                  createDate:'',
                  propertyId:'',
                  propertyName:'',
                  propertyRecordId:'',
                  recordState:'',
                  unitId:'',

                }]
        };
     },
     mounted:function() {
       this.showData();

     },
     methods: {
		// 资产处理，未开发
        showData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'POST',
              url: '/public/showWaitReadApply',
              data:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.tableData=resp.data.data;
             console.log(this.tableData)
             // this.pageSize = resp.data.count;
            })
        },
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Deal.vue